import React, { Component } from "react";
import "./index.css";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

/* Actions */
import { setAlert } from "../../../../redux/actions/misc";

/* Helpers */
import { handleStartDate, handleJobSalary, handleContractType, handleYachtName } from "../../../../helpers/job";

/* API requests */
import { getAllListings, searchListings, deleteJob, archiveJob, handleDraft } from "../../../../api-requests/job";

/* Components */
import ConfirmModal from "../../../../components/ConfirmModal";

const SearchIcon = () => (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
        <circle cx={11} cy={11} r={8} stroke="currentColor" strokeWidth={2} />
        <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    </svg>
);

class Listings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            keyword: "",
            showDropdown: false,
            selected: "",
            active: [],
            archived: [],
            drafts: [],
            isFetching: true,
            searchResults: [],
            isFetchingSearchResults: false,
            archiveTarget: null,
            isArchiving: false,
        };
    }

    componentDidMount() {
        const dash = document.getElementById("Dashboard");
        if (dash && dash.scrollTo) dash.scrollTo(0, 0);
        return getAllListings()
            .then(listings => this.setState({ drafts: listings.drafts, archived: listings.archived, active: listings.active, isFetching: false }));
    }

    renderRowCore = (post) => (
        <>
            <div className="listing-row-position">
                <p className="listing-row-position-title">{handleYachtName(post.yacht)} — {post?.position?.name || "—"}</p>
                {post.reference && <p className="listing-row-position-ref">Ref {post.reference}</p>}
            </div>
            <div className="listing-row-cell">{handleStartDate(post)}</div>
            <div className="listing-row-cell">{handleJobSalary(post)}</div>
            <div className="listing-row-cell">{handleContractType(post)}</div>
        </>
    );

    renderDrafts = (posts) => {
        if (this.state.selected) posts = posts.filter(post => post.consultant === this.state.selected);

        if (!posts.length && !this.state.isFetching) {
            return <p className="admin-empty-state">No drafted jobs.</p>;
        }
        return posts.map((post, index) => (
            <div key={index} className="listing-row admin-card">
                <Link className="listing-row-clickable" to={`/listings/add/${post.yacht._id}?job=${post._id}&status=draft`}>
                    {this.renderRowCore(post)}
                </Link>
                <div className="listing-row-actions">
                    <Link className="listing-row-primary" to={`/listings/add/${post.yacht._id}?job=${post._id}&status=draft`}>Complete listing</Link>
                    <div className="listing-row-trash" title="Delete forever">
                        <img src={require("../../../../assets/svgs/trash.svg")} alt="" />
                        <div className="listing-row-trash-confirm" onClick={() => this.handleDelete(post._id)}>
                            <img src={require("../../../../assets/svgs/trash.svg")} alt="" />
                            <p>Delete forever</p>
                        </div>
                    </div>
                </div>
            </div>
        ));
    }

    handleDelete = (_id) => {
        return deleteJob(_id).then(result => {
            if (result.success) {
                return getAllListings().then(listings => {
                    return this.setState({ drafts: listings.drafts, archived: listings.archived, active: listings.active }, () => {
                        this.props.setAlert("Listing deleted.", "success", true);
                        setTimeout(() => this.props.setAlert("Listing deleted.", "success", false), 2700);
                    });
                });
            }
        });
    }

    renderArchive = (posts) => {
        if (this.state.selected) posts = posts.filter(post => post.consultant === this.state.selected);

        if (!posts.length && !this.state.isFetching) {
            return <p className="admin-empty-state">No archived jobs yet.</p>;
        }
        return posts.map((post, index) => (
            <div key={index} className="listing-row admin-card">
                <div className="listing-row-clickable" onClick={() => this.handleRelistPosition(post)} role="button">
                    {this.renderRowCore(post)}
                </div>
                <div className="listing-row-actions">
                    <button type="button" className="listing-row-secondary" onClick={() => this.handleRelistPosition(post)}>Re-list position</button>
                    <div className="listing-row-trash" title="Delete forever">
                        <img src={require("../../../../assets/svgs/trash.svg")} alt="" />
                        <div className="listing-row-trash-confirm" onClick={() => this.handleDelete(post._id)}>
                            <img src={require("../../../../assets/svgs/trash.svg")} alt="" />
                            <p>Delete forever</p>
                        </div>
                    </div>
                </div>
            </div>
        ));
    }

    requestArchive = (post) => this.setState({ archiveTarget: post });

    cancelArchive = () => {
        if (this.state.isArchiving) return;
        this.setState({ archiveTarget: null });
    };

    confirmArchive = () => {
        const target = this.state.archiveTarget;
        if (!target || this.state.isArchiving) return;
        this.setState({ isArchiving: true });
        return archiveJob(target._id).then(result => {
            if (result.success) {
                return getAllListings().then(listings => {
                    return this.setState({ drafts: listings.drafts, archived: listings.archived, active: listings.active, archiveTarget: null, isArchiving: false }, () => {
                        this.props.setAlert("Listing archived.", "success", true);
                        setTimeout(() => this.props.setAlert("Listing archived.", "success", false), 2700);
                    });
                });
            }
            this.setState({ isArchiving: false });
        });
    };

    handleRelistPosition = (post) => {
        return handleDraft("", post, post.yacht, post.postedBy)
            .then(result => this.props.history.push(`/listings/add/${result.data.yacht}?job=${result.data._id}&status=archived`));
    }

    sortByApplications = (a, b) => {
        if (a.newApplications && b.newApplications) {
            if (a.newApplications.length > b.newApplications.length) return -1;
            if (a.newApplications.length < b.newApplications.length) return 1;
        }
        return 0;
    }

    renderPlaceholders = () => {
        return [1, 2, 3, 4, 5, 6, 7, 8].map((_, index) => <div className="listing-row-placeholder" key={index} />);
    }

    renderActive = (posts) => {
        if (this.state.selected) posts = posts.filter(post => post.consultant === this.state.selected);
        const useSearch = this.state.searchResults.length > 0;

        if (!posts.length && !useSearch && !this.state.isFetching) {
            return <p className="admin-empty-state">No active jobs.</p>;
        }

        const sorted = (useSearch ? this.state.searchResults : posts).sort(this.sortByApplications);

        return sorted.map((post, index) => (
            <div key={index} className="listing-row admin-card">
                <Link className="listing-row-clickable" to={`/listings/applications/${post.yacht._id}/job/${post._id}`}>
                    <div className="listing-row-position">
                        <p className="listing-row-position-title">{handleYachtName(post.yacht)} — {post?.position?.name || "—"}</p>
                        <div className="listing-row-counters">
                            <span className="listing-row-counter" title="Total applications">
                                <img src={require("../../../../assets/svgs/total-applications.svg")} alt="" />
                                <span className="listing-row-counter-num">{post.applications.length}</span>
                            </span>
                            <span className={`listing-row-counter${post.newApplications.length > 0 ? " is-new" : ""}`} title="New applications">
                                <img src={post.newApplications.length < 1 ? require("../../../../assets/svgs/no-new-applications.svg") : require("../../../../assets/svgs/new-applications.svg")} alt="" />
                                <span className="listing-row-counter-num">{post.newApplications.length}</span>
                            </span>
                            {post.reference && <span className="listing-row-position-ref">Ref {post.reference}</span>}
                        </div>
                    </div>
                    <div className="listing-row-cell">{handleStartDate(post)}</div>
                    <div className="listing-row-cell">{handleJobSalary(post)}</div>
                    <div className="listing-row-cell">{handleContractType(post)}</div>
                </Link>
                <div className="listing-row-actions">
                    <Link className="listing-row-primary" to={`/listings/applications/${post.yacht._id}/job/${post._id}`}>Applications</Link>
                    <div className="listing-row-more" title="More">
                        <img src={require("../../../../assets/svgs/more.svg")} alt="" />
                        <div className="listing-row-more-menu">
                            <Link className="listing-row-more-item" to={`/listings/add/${post.yacht._id}?job=${post._id}&status=active`}>
                                <img src={require("../../../../assets/svgs/edit-dark.svg")} alt="" />
                                <p>Edit details</p>
                            </Link>
                            <div className="listing-row-more-item" onClick={() => this.requestArchive(post)}>
                                <img src={require("../../../../assets/svgs/end-listing.svg")} alt="" />
                                <p>End &amp; archive</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ));
    }

    handleSearch = (keyword, status) => {
        if (!status) status = "active";
        return this.setState({ keyword }, () => {
            if (keyword.length >= 2) {
                return this.setState({ isFetchingSearchResults: true }, () => {
                    return searchListings(keyword, status)
                        .then(result => this.setState({ searchResults: result, isFetchingSearchResults: false }));
                });
            }
            return this.setState({ searchResults: [], isFetchingSearchResults: false });
        });
    }

    render() {

        const status = this.props.match.params.status;
        const activeTab = status === "archived" ? "archived" : status === "drafts" ? "drafts" : "active";

        return(
            <div className="admin-page">
                <header className="admin-page-header">
                    <div className="admin-page-header-titles">
                        <h1 className="admin-page-title">Listings</h1>
                        <p className="admin-page-subtitle">Active job listings, archived roles, and drafts.</p>
                    </div>
                </header>

                <div className="admin-toolbar">
                    <nav className="admin-tabs" aria-label="Listing status">
                        <Link to={`/listings`} className={`admin-tab${activeTab === "active" ? " is-active" : ""}`}>
                            <span className="admin-tab-label">Active</span>
                        </Link>
                        <Link to={`/listings/archived`} className={`admin-tab${activeTab === "archived" ? " is-active" : ""}`}>
                            <span className="admin-tab-label">Archived</span>
                        </Link>
                        <Link to={`/listings/drafts`} className={`admin-tab${activeTab === "drafts" ? " is-active" : ""}`}>
                            <span className="admin-tab-label">Drafts</span>
                            {this.state.drafts.length > 0 && <span className="admin-tab-count">{this.state.drafts.length}</span>}
                        </Link>
                    </nav>

                    <div className="admin-search">
                        <span className="admin-search-icon"><SearchIcon /></span>
                        <input
                            type="text"
                            value={this.state.keyword}
                            onChange={(e) => this.handleSearch(e.target.value, status)}
                            placeholder="Search listings"
                            className="admin-search-input"
                        />
                    </div>
                </div>

                <div className="listing-row-header">
                    <div className="listing-row-header-position">Position</div>
                    <div className="listing-row-header-cell">Start date</div>
                    <div className="listing-row-header-cell">Salary</div>
                    <div className="listing-row-header-cell">Contract</div>
                    <div className="listing-row-header-actions">Actions</div>
                </div>

                <div className="admin-card-list">
                    {this.state.isFetching && this.renderPlaceholders()}
                    {!this.state.isFetching && activeTab === "active" && this.renderActive(this.state.active)}
                    {!this.state.isFetching && activeTab === "archived" && this.renderArchive(this.state.archived)}
                    {!this.state.isFetching && activeTab === "drafts" && this.renderDrafts(this.state.drafts)}
                </div>

                <ConfirmModal
                    show={!!this.state.archiveTarget}
                    title={"End & archive this listing?"}
                    description={this.state.archiveTarget ? `${this.state.archiveTarget?.position?.name || "This position"} on ${handleYachtName(this.state.archiveTarget?.yacht) || "this yacht"} will be moved to the Archived tab. Candidates will no longer be able to apply. You can re-list it later from the Archived tab.` : ""}
                    confirmLabel={this.state.isArchiving ? "Archiving…" : "End & archive"}
                    cancelLabel={"Keep listing"}
                    destructive={true}
                    busy={this.state.isArchiving}
                    onConfirm={this.confirmArchive}
                    onCancel={this.cancelArchive}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ admin: state.admin });
const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({ setAlert }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Listings);
